var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.data.website,"target":"_blank","aria-label":_vm.data.name}},[_c('img',{class:_vm.data.tier,style:(("border-radius: " + (_vm.data.borderRadius))),attrs:{"src":require(("@/assets/partnerLogos/" + (_vm.data.logo)))}})])}
var staticRenderFns = []

export { render, staticRenderFns }